<!-- 导出资料 -->
<template>
<el-form label-width="100px">
    <el-row>
        <el-col :xs="24" :sm="20">
          <el-form-item v-if="this.expcom == 'b'&&templates.length>0" :label="msg('导出模板:')">
            <el-select v-model="templateKey" size="mini">
              <el-option v-for="d in templates" :key="d.key" :label="d.name" :value="d.key">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24">
            <el-form-item :label="msg('品名导出方式:')">
                <template>
                    <el-radio v-model="isMatch" label="2">{{msg('使用原始品名')}}</el-radio>
                    <el-radio v-model="isMatch" label="3">{{msg('使用替代品名')}}</el-radio>
                    <el-radio v-model="isMatch" label="1">{{msg('匹配品名库品名')}}</el-radio>
                    <el-radio v-model="isMatch" label="4">{{msg('匹配品名库品名（未匹配到保持不变）')}}</el-radio>
                </template>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="20">
            <el-form-item :label="msg('品名数量:')">
                <el-input v-model.number="baojiNameCount" type="number" size="mini">
                </el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="20" v-if="expcom.indexOf('d')>-1">
            <el-form-item :label="msg('配送方式:')">
                <template>
                    <el-select v-model="expCompany" placeholder="请选择">
                        <el-option
                        v-for="item in expCompanys"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </el-form-item>
        </el-col>
    </el-row>
    
    <el-row>
        <el-col :xs="24" :sm="20">
            <el-form-item :label="msg('批次录入时间')" label-width="100px">
                <el-date-picker  v-model="pcDate"  type="datetimerange"  :range-separator="msg('至')" 
                    value-format="yyyy-MM-dd HH:mm:ss"
                    end-placeholder=""
                    size="small"
                >
                </el-date-picker>
            </el-form-item>
        </el-col>
    </el-row>

    <el-row>
        <el-col :xs="24" :sm="20">
            <el-form-item :label="msg('输入批次')" label-width="100px">
                <el-input 
                    v-model="pici" style="margin-top:0px;" size="small">
                </el-input>
            </el-form-item>
        </el-col>
    </el-row>

    <el-row>
        <el-table :data="batchs" style="width: 100%" size="small" ref="dataTable" max-height="400" stripe>
          <el-table-column label="批次信息">
            <el-table-column type="selection" min-width="55"></el-table-column>
            <el-table-column type="index" :label="msg('序号')" min-width="60" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="expBatch" :label="msg('批次')" min-width="120" sortable :show-overflow-tooltip="true"></el-table-column>
          </el-table-column>
          <el-table-column align="center">
                <template slot="header">
                    <el-button type="primary" size="mini"  @click="getPici"><i class="el-icon-check"></i><span>{{msg('搜索批次')}}</span></el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-row> 

    <div style="text-align:center; margin-top: 15px;">
        <el-button v-if="expcom == 'l'" type="success" size="mini"  @click="checkExportData"><i class="el-icon-check"></i><span>{{msg('较正数据')}}</span></el-button>
        <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('导出')}}</span></el-button>
        <el-button  size="mini" @click="close">{{msg('取消')}}</el-button>
    </div>

</el-form> 
</template>

<script>
export default {
  name: 'ExpressSorting',
  data(){
    return{
        isMatch:null,
        baojiNameCount:null,
        batchs:[],
        pcDate:[],
        expCompany:null,
        expCompanys:[],
        pici:null,
        templates:[],
        templateKey:null
    }
  }, 
  props: {
      expcom:String,
      ids:String
    },
  computed:{
  },
  mounted: function(){
  },
  methods:{
    init(){
        this.getCompanys();
        this.isMatch = null;
        this.baojiNameCount = null;
        this.batchs= [];
        this.pcDate = [];
        this.expCompany = null;
        this.pici = null
        this.getTemplates();
    },
    getCompanys(){
        if(this.expcom.indexOf('d')>-1){
            this.$axios.get(this.$kit.api.getExpCompany)
                .then((result)=> {
                    if(result.status){
                        this.expCompanys = result.data;
                    }
                });
        }
    },
    getPici(){
        if(this.pcDate.length <= 0){
            this.$message(this.msg('请选择批次日期'));
            return;
        }
        let starDate = this.pcDate[0];
        let endDate = this.pcDate[1];

        this.batchs.splice(0,this.batchs.length);
        this.$axios.get(this.$kit.api.stock.getPiciByDate+"?starDate="+starDate+"&endDate="+endDate+"&pici="+this.pici)
            .then((result) => {
                let data = result.data;
                if(data.length > 0){
                    data.forEach(e => {
                        this.batchs.push(
                            {
                                expBatch:e
                            }
                        )
                    });
                }else{
                    this.$message(this.msg('无批次信息'));
                }
            });

    },
    onSubmit(){
        if(!this.isMatch){
            this.$message(this.msg('请选择品名导出方式'));
            return;
        }
        if(this.expcom.indexOf('d')>-1){
            if(!this.expCompany){
                this.$message(this.msg('请选择配送方式'));
                return;
            }
        }
        var selectes = this.$refs.dataTable.selection;

        let pc = '';
        if(selectes.length > 0){
            pc = selectes.map(s=>s.expBatch).join(",");
        }
        this.$emit("close-dg",
            {
                isMatch: this.isMatch,
                baojiNameCount: this.baojiNameCount,
                expBatchs:pc,
                expCompany:this.expCompany,
                templateKey:this.templateKey,
                doExport:true,
            },
        )
    },
    //校正报机数据，将选中的数据，重新校正品名，保存最新的品名数据
    checkExportData(){
        if(!this.ids){
            this.$message(this.msg('请选择要校正的数据'));
            return;
        }
        this.$axios.post(this.$kit.api.export.checkBaoji, this.ids)
            .then((result) => {
                if(result.status){
                    this.$message(this.msg('校正报机数据成功'));
                }else{
                    this.$message(this.msg(result.msg || '校正报机数据失败'));
                }
            });
    },
    close(){
        this.$emit("close-dg",
            {
                isMatch: 2,
                baojiNameCount: null,
                expBatchs:'',
                expCompany:null,
                templateKey:null,
                doExport:false,
            },
        )
    },
    getTemplates() {
      var _this = this;
      this.templates = [];
      if (this.expcom == 'b') {
        this.$axios.get(this.$kit.api.user.qgConfig)
            .then((result) => {
              if (result.status) {
                if (result.data && result.data.length > 0) {
                  var curKey = null;
                  for (var i = 0; i < result.data.length; i++) {
                    var e = result.data[i]
                    if (e.xvalue) {
                      _this.templates.push({
                        key: e.xkey,
                        name: e.xlabel
                      })
                      if (e.remark == 'default') {
                        curKey = e.xkey;
                      }
                    }
                  }
                  if (curKey == null && _this.templates.size > 0) {
                    curKey = _this.templates[0].key;
                  }
                  _this.templateKey = curKey;
                }
              }
            })
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
